export default "__VITE_ASSET__DFNzyPeM__"